import { makeStyles } from '@material-ui/core';
import { themeColor } from '../../mui-theme';
import { rem } from '../helpers/dimension-helper';

export const trainingModeStyles = makeStyles(theme => ({
  trainingModeBackground: {
    backgroundColor: `${themeColor.trainingBackground}!important`,
  },
  trainingWaterMark: {
    position: 'absolute',
    width: '100%',
    height: '11.4583vh',
    right: '11.00585vw',
    left: '6.5%',
    top: '45%',
    fontFamily: 'Raleway',
    fontStyle: 'normal',
    fontWeight: 'bold',
    fontSize: rem(5.5),
    lineHeight: '100px',
    alignItems: 'center',
    textAlign: 'center',
    color: themeColor.watermark,
    mixBlendMode: 'normal',
    transform: 'rotate(-30deg)',
    '@media (max-height: 900px)': {
      fontSize: rem(4.5),
    },
    '@media (max-height: 768px)': {
      fontSize: rem(3.9),
    },
    '@media (max-height: 720px)': {
      fontSize: rem(3.5),
    },
    '@media (max-height: 576px)': {
      fontSize: rem(2.8),
    },
    '@media (aspect-ratio: 4/3)': {
      '@media (max-height: 1200px)': {
        fontSize: rem(3.9),
      },
      '@media (max-height: 768px)': {
        fontSize: rem(2.8),
      },
    },
  },
  fullMiddleAreaTrainingWaterMark: {
    left: '0 !important',
  },
  menuPanelTrainingWaterMark: {
    left: '1.5vw !important',
  },
  dialogPaper: {
    borderRadius: 2,
    minHeight: '65.1vh',
  },
  dialogPaperFullWidth: {
    maxWidth: '46.85vw',
  },
  warningPaperFullWidth: {
    maxWidth: '58.56vw',
  },
  closeButton: {
    minWidth: '8.41vw',
    width: 'auto',
    height: '7.29vh',
    borderRadius: 2,
    marginBottom: '3.58vh',
    position: 'absolute',
    left: '1.35%',
    fontSize: rem(1),
    fontWeight: 500,
    letterSpacing: 1.43,
    lineHeight: 1,
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack}`,
    border: `1px solid ${themeColor.secondaryLight}`,
    backgroundColor: themeColor.white,
    color: themeColor.defaultTextColor,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
    '& .MuiTouchRipple-ripple': {
      color: `${theme.palette.secondary.main}`,
    },
  },
  acceptButton: {
    minWidth: '8.41vw',
    height: '7.29vh',
    borderRadius: 2,
    marginBottom: '3.58vh',
    marginRight: 12,
    fontSize: rem(1),
    fontWeight: 500,
    letterSpacing: 1.43,
    lineHeight: 1,
    boxShadow: `0 1px 1px 0 ${themeColor.semitransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  dialogContainerMain: {
    backgroundColor: themeColor.lightBackground,
    flex: '1 1 0',
    textAlign: 'center',
  },
  dialogContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    backgroundColor: themeColor.lightBackground,
  },
  dialogItemContent: {
    display: 'flex',
    justifyContent: 'flex-end',
    padding: '1rem 0rem 0rem 1.25rem',
  },
  dialogCancelItemContent: {
    display: 'flex',
    justifyContent: 'flex-start',
    padding: '1rem 0rem 0rem 1.25rem',
  },
  doubleLeftTradeMark: {
    left: '-25vw',
  },
  doubleRightTradeMark: {
    left: '25vw',
  },
  centerTradeWaterMark: {
    left: '3% !important',
    mixBlendMode: 'multiply',
    width: 'auto',
    '@media (aspect-ratio: 4/3)': {
      left: '-10% !important',
    },
  },
  trainingCommandMenuModal: {
    overflow: 'hidden',
    position: 'relative',
  },
  tradeMarkNoWarp: {
    whiteSpace: 'nowrap',
    left: '0',
  },
  centerRedeemTrainingTradeMark: {
    mixBlendMode: 'multiply',
    '@media (aspect-ratio: 4/3)': {
      left: '0 !important',
    },
  },
  centerRedeemAmountTrainingTradeMark: {
    mixBlendMode: 'multiply',
    left: '-4.5% !important',
    '@media (aspect-ratio: 4/3)': {
      left: '-12% !important',
    },
  },
  disableBoxShadow: {
    '& > button:first-child, & > button:last-child': {
      boxShadow: 'none !important',
    },
  },
}));
